module.exports = __webpack_public_path__ + "static/media/logo2.05b86ad4.png";